<header class="wf-peppol-status-card__header">
  <div class="wf-peppol-status-card__status">
    <wf-icon
      iconClass="small"
      [iconName]="config().icon"
      [class]="'wf-peppol-status-card__icon ' + config().colorClass"
    />
    <span class="wf-peppol-status-card__label wf-text-md-semibold">
      {{ config().label | translate }}
    </span>
  </div>
  @if (event().date; as date) {
    <span class="wf-peppol-status-card__date wf-text-sm-regular">
      {{ date | date: 'dd.MM.yyyy HH:mm' }}
    </span>
  }
</header>

@if (isRejected()) {
  <div class="wf-peppol-status-card__fields">
    @if (event().rejectionCode; as rejectionCode) {
      <p class="wf-peppol-status-card__field wf-text-sm-regular">
        <span class="wf-text-sm-semibold"
          >{{ 'PEPPOL.Detail.RejectionReasonLabel' | translate }}:</span
        >
        {{ 'PEPPOL.REJECT_REASON.' + rejectionCode | translate }}
      </p>
    }
    @if (event().requestedAction; as requestedAction) {
      <p class="wf-peppol-status-card__field wf-text-sm-regular">
        <span class="wf-text-sm-semibold"
          >{{ 'PEPPOL.Detail.RequestedActionLabel' | translate }}:</span
        >
        {{ 'PEPPOL.REQUIRED_ACTION.' + requestedAction | translate }}
      </p>
    }
  </div>
}

@if (event().user; as user) {
  <footer class="wf-peppol-status-card__user">
    <wf-avatar [name]="user.fullName" [userLogin]="user.email" size="md" />
    <div class="wf-peppol-status-card__user-text">
      <span class="wf-text-sm-medium">{{ user.fullName }}</span>
      <span class="wf-text-sm-regular">{{ user.email }}</span>
    </div>
  </footer>
}
